import { Component, inject, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { HeaderService } from "@app/components/header/header.service";
import { AuthTokenService } from "@app/services/auth-token.service";

@Component({
    selector: "app-make-sso-decision",
    template: require("./make-sso-decision.component.html"),
})
export class MakeSsoDecisionComponent implements OnInit {
    private router = inject(Router);
    private headerService = inject(HeaderService);
    private auth = inject(AuthTokenService);

    email = "";

    ngOnInit(): void {
        this.headerService.setDisplayRightContent(false);

        this.email = this.auth.getSsoIdentity().email.trim();
    }

    onCreateProfile(): void {
        this.router.navigate(["/sso/create-profile"]);
    }

    onFindProfile(): void {
        this.router.navigate(["/sso/search-profile"]);
    }
}
